import React from "react";
import { isViewVisible } from "../../../utils/ViewSettings";
import ResourcesView from "./components/ResourcesView";
import Rbac from "../../../utils/Rbac";

export const rbac = new Rbac({
  _rbac: {
    admin: {
      write: true,
      editResource: true,
      editStatus: true,
      configureResource: true,
    },
    manager: {
      write: false,
      editResource: true,
      editStatus: true,
      configureResource: true,
    },
    "manager-location": {
      write: false,
      editResource: false,
      editStatus: true,
      configureResource: false,
    },
    user: {
      write: false,
      editResource: false,
      editStatus: false,
      configureResource: false,
    },
    "garage-staff": {
      write: false,
      editResource: false,
      editStatus: true,
      configureResource: false,
    },
  },
});

export const ResourcesPage = (props) => {
  let _view = typeof props.view === "undefined" || props.view === null ? "index" : props.view;
  let indexView = isViewVisible("resources", "resources") ? "resources" : "";
  return (
    <>
      {(_view === "resources" || (_view === "index" && indexView === "resources")) && (
        <ResourcesView
          name={"resources"}
          dispatch={props.dispatch}
          params={props.params}
          returnPath={props.returnPath}
        />
      )}
    </>
  );
};
